import { enumUIModes } from "../constants";
import { Globals } from "../CoreApp/Globals";

export function isInReporting() {
  return Globals._uiConfig.GetUIMode() === enumUIModes.reports;
}
